import { AppBar, Toolbar, Typography } from "@material-ui/core";
import React from "react";

export default function NavBar() {
    return (
        <AppBar position="static" style={{ marginBottom: "1vh" }}>
            <Toolbar>
                <Typography variant="h5">Visualising the Effects of COVID-19 on the Electricity Grid in Victoria, Australia</Typography>
            </Toolbar>
        </AppBar>
    )
}

